import Card from "@shared/components/card";
import { CARD_VARIANT, ICard } from "@shared/components/card/types";
import { FC } from "react";

const ExploreCard: FC<ICard> = (props) => {
  return (
    <>
      <div className="sm:hidden block">
        <Card
          {...props}
          showShoppingCart
          title={props.title_short || props.title}
          variant={CARD_VARIANT.LIST}
          hugElement={true}
          linkTarget="_blank"
          showSubscriptionBadge={false}
          noBorder={false}
        />
      </div>
      <div className="hidden sm:block">
        <Card
          {...props}
          linkTarget="_blank"
          title={props.title_short || props.title}
          variant={CARD_VARIANT.GRID}
          hugElement={false}
          showSubscriptionBadge={false}
          noBorder={true}
        />
      </div>
    </>
  );
};
export default ExploreCard;
